module.exports = __webpack_public_path__ + "img/1.68d91b10.png";